import { render } from "./BooleanField.vue?vue&type=template&id=0c0168ae&scoped=true"
import script from "./BooleanField.vue?vue&type=script&lang=js"
export * from "./BooleanField.vue?vue&type=script&lang=js"

import "./BooleanField.vue?vue&type=style&index=0&id=0c0168ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0168ae"]])

export default __exports__